import React, { FC } from 'react';
import { kebabCase } from 'lodash';
import styled from 'styled-components';
import { globalTheme } from '@cld/component-theme';
import { typography } from '@cld/typography';
import { Selectable, SelectableProps } from '../../../common/selectable/Selectable';
import { SMALL_SELECTABLES_ITEM_WIDTH } from '../../../common/selectable/containers/SmallSelectabes';
import { OverlayPlacementName } from '../../../../../types';
import { PlacementOption } from './PlacementOption';

const Root = styled.div`
  width: ${SMALL_SELECTABLES_ITEM_WIDTH}px;
`;

const Text = styled.div`
  ${typography.xxs.regular};
  text-align: center;
  padding-top: ${globalTheme.spacing.xxs};
`;

export interface SelectablePlacementOptionProps extends SelectableProps {
  placement: OverlayPlacementName,
  label: string,
}

export const SelectablePlacementOption: FC<SelectablePlacementOptionProps> = ({ isSelected, onClick, placement, label }) => (
  <Root>
    <Selectable isSelected={isSelected} onClick={onClick} data-test={`placement-${kebabCase(String(placement))}`}>
      <PlacementOption placement={placement} />
    </Selectable>
    <Text>{label}</Text>
  </Root>
);
